import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import Loadingcomponent from "../loader/loadingcomponent";
import { getImgSrc } from "../../services/common/CommonUtils";
import { use } from "i18next";
import { useNavigate } from "react-router-dom";
import MessageModal from "../cdr/subscriptionDialog";
import { setCdrCards, setCdrtransid, setIsCdrCardsData } from "../../reducer/cdrSlice";
import BottomModalComponent from "../common/bottom-modal";
import { useTranslation } from "react-i18next";

const ViewcallHistoryButton = ({viewCallHistoryIcon, viewCallHistory, cdrLoading, isVipCheck}) =>{
  let isCdrRedirect = localStorage.getItem("cdr") === "true";
  const [enabled, setEnabled] = useState(false);
  const navigate = useNavigate();
  const [showCenterModal, setShowCenterModal] = useState(false);
  const [showErrorModal, setshowErrorModal] = useState(false);
  const [errormessage, seterrormessage] = useState("");
  const {t} = useTranslation();
  const customerprofile = useSelector(
    (state) => state.userdata.value.customerprofile
  );
  const { cdrData = {} } = useSelector((store) => store);
  const cdrCards = cdrData?.cdrCards || [];

  const dispatch = useDispatch();
  const toggleerrormodal =()=>{
    setshowErrorModal(!showErrorModal);
  }
  const {
    data: { data } = {},
    isLoading,
    isFetching,
  } = useQuery(
    ["cdrCards", "cdr/getjson", { catg: "cdrcards" }, {}, false, "cdr"],
    {
      enabled: enabled,
      retry: false,
      onSuccess: ({ data: udata }) => {
        setEnabled(false);
        if (udata?.status === "0") {
            if(udata?.data){
              setShowCenterModal(true) 
            }else{
              dispatch(setIsCdrCardsData(udata?.data));
              dispatch(setCdrtransid(udata.response));
              navigate("/verification");
            }
          if (udata?.response && udata?.response?.cards) {
            dispatch(setCdrCards(udata?.response?.cards));
          }
        }else{
          setshowErrorModal(true);
          seterrormessage(udata?.data?.message);
        }
      },onError:({ data: udata })=>{
        setEnabled(false);
        seterrormessage(udata?.data?.message);
      }
    }
  );
  const handleToggle = () =>{
    setShowCenterModal(!showCenterModal);
  }

  const cards = cdrCards ? cdrCards : data?.response?.cards;

  useEffect(() => {
    if(isCdrRedirect && cards.length > 0){
      setShowCenterModal(true);
      localStorage.removeItem("cdr");
    }
  }, [isCdrRedirect, cards])

//   <div className='shimmerBG shimmer-h20' style={{width: '40%'}}></div>
  return (
    <>
    {cdrLoading ?  <><hr /><div className='shimmerBG shimmer-h20 sp17-viewdetails-button gap-10' style={{width: '40%'}}></div></> : 
    <>
      <hr />
      <div
        class="sp17-viewdetails-button gap-10"
        onClick={() => {
          if(isCdrRedirect){
            setShowCenterModal(true);
          }else{
            setEnabled(true);
          }
        }}
      >
        <a>
          <img src={getImgSrc(viewCallHistoryIcon, true)} /> {viewCallHistory}
          <img src={ process.env.PUBLIC_URL + "/assets/images/sprint16/right-arrow-red.svg"}/> 
        </a>
        <div className="cardsDataLoading">
            {isLoading || isFetching ? <Loadingcomponent /> : ""}
        </div>
      </div>
      </>
    }
      {cards?.length > 0 && (
        <MessageModal
          show={showCenterModal}
          toggleModal={handleToggle}
          showPremium={false}
          cdrCardsData={cards}
        />
      )}
      { <BottomModalComponent
          show = {false}
          popuptype = "fail"
          shouldEnableBackdropClick= {true}
          respmessage = {errormessage ? errormessage : t('somethingwentwrong')}
          togglebottomModal = {toggleerrormodal}
        ></BottomModalComponent>}

    </>
  );
}

export default ViewcallHistoryButton;
